// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HukS","colMin":"styles_colMin__2hBuT"};